import {
  FEATURES_PAGE,
  FEATURE_1_PAGE,
  FEATURE_2_PAGE,
  FEATURE_3_PAGE,
  FEATURE_4_PAGE,
  OUR_FOCUS_PAGE,
  GAS_STATION_PAGE,
  CONVENIENCE_RETAIL_PAGE,
  HOSPITALITY_PAGE,
  STORE_RETAIL_PAGE,
  ABOUT_PAGE,
  COMPANY_PAGE,
  MANAGEMENT_PAGE,
  WORK_WITH_US_PAGE,
  CONTACT_PAGE,
  HELP_PAGE,
  FAQS_PAGE,
  KNOWLEDGEBASE_PAGE,
} from '@/constants/pagesUrl.js';

const URL = {
  framework: '/framework',
  navigation: {
    features: {
      title: FEATURES_PAGE,
      sub_nav: {
        feature_1: FEATURE_1_PAGE,
        feature_2: FEATURE_2_PAGE,
        feature_3: FEATURE_3_PAGE,
        feature_4: FEATURE_4_PAGE,
      },
    },
    our_focus: {
      title: OUR_FOCUS_PAGE,
      sub_nav: {
        gas_stations: GAS_STATION_PAGE,
        convenience_retail: CONVENIENCE_RETAIL_PAGE,
        hospitality: HOSPITALITY_PAGE,
        store_retail: STORE_RETAIL_PAGE,
      },
    },
    about: {
      title: ABOUT_PAGE,
      sub_nav: {
        company: COMPANY_PAGE,
        management: MANAGEMENT_PAGE,
        work_with_us: WORK_WITH_US_PAGE,
        contact_us: CONTACT_PAGE,
      },
    },
    help: {
      title: HELP_PAGE,
      sub_nav: {
        faqs: FAQS_PAGE,
        knowledgebase: KNOWLEDGEBASE_PAGE,
      },
    },
  },
};

export default URL;
